<template>
  <div class="project-card">
    <div class="cover-view" @click="handlePreview(item)">
      <div class="cover-arrow">{{ item.type }}</div>
      <el-image fit="cover" v-if="item.cover" :src="item.cover"></el-image>
      <NoCover v-if="!item.cover"><div>暂无图片</div></NoCover>
    </div>
    <div class="content">
      <div class="head">
        <div class="title" @click="handlePreview(item)">{{ item.title }}</div>
        <div class="operation" v-if="item.auditStatus !== 2 || isDraft">
          <el-link @click="handlePreview(item)">预览</el-link> |
          <el-link @click="handleEdit">编辑</el-link>
          |
          <el-link @click="handleDelete(item.id)">删除</el-link>
          <template v-if="item.auditStatus === 3">
            |
            <el-link @click="showShare = true">转发</el-link>
          </template>
        </div>
        <div class="operation" v-if="item.auditStatus === 2 && !isDraft">
          <el-link @click="handlePreview(item)">预览</el-link>
        </div>
      </div>
      <div class="footer">
        <div class="left">
          <div class="time">{{ item.time }}</div>
          <div class="stat" v-if="!isDraft && item.auditStatus === 3">
            <div class="stat-item">
              <SvgIcon class="icon" iconClass="read"></SvgIcon>阅读：{{
                item.readCount
              }}
            </div>
            |
            <div class="stat-item">
              <SvgIcon class="icon" iconClass="like"></SvgIcon>点赞：{{
                item.likeCount
              }}
            </div>
            |
            <div class="stat-item">
              <SvgIcon class="icon" iconClass="share"></SvgIcon>分享：{{
                item.shareCount
              }}
            </div>
          </div>
        </div>
        <div class="right" v-if="!isDraft">
          <el-select class="publish-target" v-model="item.publishTarget" @change="updatePublishTarget">
            <el-option label="同时发布到APP和小程序" :value="1"></el-option>
            <el-option label="仅发布到app" :value="2"></el-option>
            <el-option label="仅发布到小程序" :value="3"></el-option>
          </el-select>
          <span :class="'status' + item.auditStatus">{{ item.auditMsg }}</span>
        </div>
      </div>
    </div>

    <!-- 预览 -->
    <MobileBox
      :title="currentItem.title"
      append-to-body
      @close="currentItem = {}"
      v-if="currentItem.type"
      :visible.sync="showPreview"
    >
      <ServicePreview :item="currentItem" :isDraft="isDraft"></ServicePreview>
    </MobileBox>
    <!-- 转发 -->
    <el-dialog
      width="530px"
      v-if="showShare"
      :visible.sync="showShare"
      title="转发到设区"
    >
      <div class="project-sm">
        <el-image fit="cover" :src="item.cover" class="cover"></el-image>
        <div class="title">{{ item.title }}</div>
      </div>
      <el-input
        type="textarea"
        class="share-text"
        placeholder="说说分享心得～"
        :maxlength="150"
        show-word-limit
        v-model="shareText"
      >
      </el-input>
      <div style="display: flex; justify-content: flex-end">
        <el-button size="small" @click="showShare = false">取消</el-button>
        <el-button size="small" type="primary" @click="handleShare"
          >转发</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SvgIcon from "@/components/SvgIcon";
import NoCover from "@/components/NoCover";
import ServicePreview from "@/components/ServicePreview";
import MobileBox from "@/components/MobileBox";
import { fetchDeleteProject, fetchDeleteDraft, fetchShareSocial, fetchUpdatePlatform } from "@/api";
export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    isDraft: Boolean,
  },
  data() {
    return {
      currentItem: {},
      showShare: false,
      shareText: "",
    };
  },
  computed: {
    ...mapGetters("user", { userId: "userId" }),
    showPreview: {
      get() {
        return !!this.currentItem.type;
      },
      set() {
        this.currentItem = {};
      },
    },
  },
  components: { SvgIcon, NoCover, ServicePreview, MobileBox },
  methods: {
    handleShare() {
      const shareText = this.shareText.trim();
      if (!shareText) {
        this.$message.error("请说说分享心得～");
        return;
      }
      const params = {
        tenant: 1,
        kind: 3,
        desc: shareText,
        forward: {
          mediaId: this.item.id,
          type: 1,
          // 全屋=3 自定义=4
          mediaType: this.item.type === "自定义案例" ? 4 : 3,
          coverKey: this.item.cover,
          userId: this.userId,
          title: this.item.title,
          text: "",
        },
      };
      fetchShareSocial(params).then(() => {
        this.$message.success("转发成功!");
        this.showShare = false;
      });
    },

    async updatePublishTarget(value) {
      const res = await fetchUpdatePlatform({
        id: this.item.id,
        publishTarget: value
      })
      if(res.code === 0) {
        this.$message.success("修改成功!");
      }
    },
    handleEdit() {
      const { type, id = 0 } = this.item;
      let href = "";
      if (type === "自定义案例") {
        href = `/editorPro/custom?${
          this.isDraft ? "draftId" : "projectId"
        }=${id}`;
      } else {
        href = `/editorPro/room?${
          this.isDraft ? "draftId" : "projectId"
        }=${id}`;
      }
      if (!this.isDraft) {
        this.$confirm(
          "编辑后的案例需要重新审核，有可能影响发布效果",
          "确定要编辑吗？",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "none",
            center: true,
          }
        ).then(() => {
          this.$router.push(href);
        });
      } else {
        this.$router.push(href);
      }
    },
    handleDelete(id) {
      this.$confirm("删除后将不可恢复", "确定要删除吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "none",
        center: true,
      }).then(() => {
        if (this.isDraft) {
          fetchDeleteDraft(id).then(() => {
            this.$message.success("删除成功");
            location.reload();
          });
        } else {
          fetchDeleteProject(id).then(() => {
            this.$message.success("删除成功");
            location.reload();
          });
        }
      });
    },
    handlePreview(item) {
      this.currentItem = item;
    },
  },
};
</script>

<style lang="scss" scoped>
.stat-item {
  margin: 0 10px;
}
.stat-item:nth-child(1) {
  margin-left: 0;
}
.status2 {
  color: #f4b030;
}
.status4 {
  color: #e85858;
}
.status3 {
  color: #4dd38b;
}
.icon {
  margin-right: 2px;
}
.project-card {
  background: #fff;
  border-bottom: 1px solid #ebebeb;
  padding: 30px 0 30px 9px;
  display: flex;
  .cover-view {
    cursor: pointer;
    border-radius: 8px;
    overflow: hidden;
    width: 230px;
    height: 130px;
    position: relative;
    background: #f6f6f6;
    .el-image {
      width: 100%;
      height: 100%;
    }
    .cover-arrow {
      position: absolute;
      left: 0;
      top: 0;
      background: rgba($color: #000000, $alpha: 0.58);
      display: flex;
      align-items: center;
      color: #fff;
      font-size: 14px;
      border-top-left-radius: 8px;
      border-bottom-right-radius: 8px;
      z-index: 11;
      padding: 0 5px;
      height: 26px;
    }
  }
  .content {
    flex: 1;
    margin-left: 30px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-size: 14px;
    color: #333;
    .head {
      display: flex;
      justify-content: space-between;
      .title {
        font-size: 18px;
        color: #333;
        cursor: pointer;
      }
      .operation {
        display: flex;
        align-items: center;
        .el-link {
          margin: 0 5px;
        }
      }
    }
    .footer {
      display: flex;
      justify-content: space-between;
      .left {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        .stat {
          display: flex;
          margin-top: 10px;
          align-items: center;
        }
      }
      .right {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        &::after {
          content: "";
        }
      }
    }
  }
  .project-sm {
    display: flex;
    .cover {
      width: 100px;
      height: 100px;
      border-radius: 8px;
    }
    .title {
      font-size: 14px;
      line-height: 28px;
      margin-top: 26px;
      margin-left: 14px;
      color: #333;
    }
  }
  .share-text {
    margin-top: 12px;
    min-height: 80px;
    border-radius: 2px;
  }
  .publish-target{
    margin-bottom: 20px;
  }
}
</style>